import { Card, CardBody, CardText, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

interface CardComponentProps {
  id: number;
  name: string;
  description: string;
  previewImageUrl?: string | null;
  createdOn: string;
}

const CardComponent = ({
  id,
  name,
  description,
  previewImageUrl,
  createdOn,
}: CardComponentProps) => {
  const timeAgo = getTimeAgo(createdOn);

  return (
    <Col md={6} sm={12}>
      <Link to={`/recipe/${id}`} style={{ textDecoration: "none" }}>
        <Card className="mb-3 recipe-card" style={{ cursor: "pointer" }}>
          <div className="d-flex">
            {previewImageUrl && (
              <img
                src={previewImageUrl}
                alt={name}
                style={{
                  width: "140px",
                  height: "140px",
                  objectFit: "cover",
                }}
              />
            )}
            <CardBody>
              <h5 className="card-title">{name}</h5>
              <CardText className="text-muted" style={{ fontSize: "0.9rem" }}>
                {description.length > 100
                  ? description.substring(0, 100) + "..."
                  : description}
              </CardText>
              <CardText>
                <small className="text-muted">Last updated {timeAgo}</small>
              </CardText>
            </CardBody>
          </div>
        </Card>
      </Link>
    </Col>
  );
};

function getTimeAgo(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins} mins ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hours ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 30) return `${diffDays} days ago`;
  const diffMonths = Math.floor(diffDays / 30);
  return `${diffMonths} months ago`;
}

export default CardComponent;
